export default {
  api: {
    endpoint: String(process.env.VUE_APP_PROJECT_API)
  },
  tip: process.env.VUE_APP_TIP === 'true' || false,
};
